"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertSerializer = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
const alert_status_serializer_1 = require("./alert-status.serializer");
class AlertSerializer extends dp_http_client_lib_1.PageableSerializer {
    constructor(alertStatusSerializer = new alert_status_serializer_1.AlertStatusSerializer()) {
        super();
        this.alertStatusSerializer = alertStatusSerializer;
    }
    serializeOne(data) {
        return {
            id: data.id,
            alertStatus: data.alertStatus
                ? this.alertStatusSerializer.serializeOne(data.alertStatus)
                : null,
            enrollmentPeriodId: data.enrollmentPeriodId,
            entityType: data.entityType,
            entityId: data.entityId,
            message: data.message,
            subject: data.subject,
            platformId: data.platformId,
        };
    }
}
exports.AlertSerializer = AlertSerializer;
//# sourceMappingURL=alert.serializer.js.map